import { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { VM } from '../VM';

import { Index as ToolCategories } from '../../__personal/components/toolcategories/Index';
import { RenderAPI } from '../../__personal/components/global/RenderAPI';
import { Switching } from '../../__personal/components/swtiching/Index'
import { Result } from '../../__personal/components/search/devices/mobile/Result'
import TestComponent from '../../__personal/components/TestComponent';
import { SaveList } from '../../__personal/components/save/devices/mobile/SaveList';
import { Index as Default } from '../../__personal/components/Index'
import { Index as NotFound } from '../../__personal/components/notFound/Index'
import More from '../../__personal/components/more/devices/mobile/Index'
import { ToolAccess } from '../../__personal/components/profile/accesstools/devices/mobile/ToolAccess'

let view = VM();
const Navigation = lazy(() => import(`../../__personal/components/layouts/navigations${view}/Index`))
// const Home = lazy(() => import (`../../__personal/components/home${view}/Index`))
const Library = lazy(() => import (`../../__personal/components/library${view}/Index`))
const Article = lazy(() => import (`../../__personal/components/library/article${view}/Index`))
const Welcome = lazy(() => import (`../../__personal/components/personalization/welcomeOnboarding${view}/Index`))
const Selection = lazy(() => import (`../../__personal/components/personalization/onboardingSelection${view}/Index`))
const AccountSetup = lazy(() => import (`../../__personal/components/personalization/accountSetup${view}/Index`))

// Publication
const Publication = lazy(() => import(`../../__personal/components/publication${view}/Index`))
const ViewPublication = lazy(() => import(`../../__personal/components/publication/view${view}/Index`))

// Bulletin
const Bulletin = lazy(() => import(`../../__personal/components/bulletin${view}/Index`))
const ViewBulletin = lazy(() => import(`../../__personal/components/bulletin/view${view}/Index`))

// Save
const Save = lazy(() => import(`../../__personal/components/save${view}/Index`))

// Article
const Articles = lazy(() => import(`../../__personal/components/article${view}/Index`))
const View = lazy(() => import(`../../__personal/components/article/view${view}/Index`))

// Search
const Search = lazy(() => import (`../../__personal/components/search${view}/Index`))

// Notification
const Notification = lazy(() => import (`../../__personal/components/notification${view}/Index`))

// Notification
const Onboarding = lazy(() => import (`../../__personal/components/personalization/onboarding${view}/Index`))

// Profile
const Profile = lazy(() => import (`../../__personal/components/profile${view}/Index`))

export const WebRoute = () => {
    const location = useLocation().pathname;
    
    return (
        <Switch>
            {/* HOME */}
            <Route exact path="/psl/switching/:params" render={props=><Switching {...props}/>} />
            {/* <Route exact path="/psl" render={props=>(Render(Home, props, location))}/> */}
            {/* <Route exact path="/psl/more" render={props=>(Render(Settings, props, location))} /> */}
            <Route exact path="/psl/tool-categories/:params" render={props=>(Render(ToolCategories, props, location))} />
            <Route exact path="/psl/library" render={props => (Render(Library, props, location))} />
            <Route exact path="/psl/article" render={props => (Render(Article, props, location))} />

            <Route exact path="/psl/search/result" render={props => (Render(Result, props, location))} />
            <Route exact path="/psl/test" render={props => (Render(TestComponent, props, location))} />

            <Route exact path="/psl/welcome" render={props => (Render(Welcome, props, location))}/>
            <Route exact path="/psl/selection" render={props => (Render(Selection, props, location))}/>
            <Route exact path="/psl/account-setup" render={props => (Render(AccountSetup, props, location))}/>


            {/* New routes ↓ */}
            
            {/* Default */}
            <Route exact path="/psl" render={props => (Render(Default, props, location))} />

            {/* Publication */}
            <Route exact path="/psl/publication" render={props => (Render(Publication, props, location))} />
            <Route exact path="/psl/publication/:params/:params" render={props => (Render(ViewPublication, props, location))} />

            {/* Bulletin */}
            <Route exact path="/psl/bulletin" render={props => (Render(Bulletin, props, location))} />
            <Route exact path="/psl/bulletin/:params" render={props => (Render(ViewBulletin, props, location))} />

            {/* Save */}
            <Route exact path="/psl/save" render={props => (Render(Save, props, location))} />
            <Route exact path="/psl/save/:params" render={props => (Render(SaveList, props, location))} />

            {/* Article */}
            <Route exact path="/psl/articles" render={props => (Render(Articles, props, location))} />
            <Route exact path="/psl/view/:params/:params" render={props => (Render(View, props, location))} />

            {/* Search */}
            <Route exact path="/psl/search" render={props => (Render(Search, props, location))} />
            

            {/* Notification */}
            <Route exact path="/psl/notification" render={props => (Render(Notification, props, location))}/>

            {/* Onboarding */}
            <Route exact path="/psl/onboarding" render={props => (Render(Onboarding, props, location))}/>

            {/* More */}
            <Route exact path="/psl/more" render={props => (Render(More, props, location))}/>

            {/* Profile */}
            <Route exact path="/psl/profile" render={props => (Render(Profile, props, location))}/>
            <Route exact path="/psl/profile/tool-access" render={props => (Render(ToolAccess, props, location))}/>

            {/* 404 NOT FOUND */}
            <Route>
                <NotFound/>
            </Route>
        </Switch>
    )
}

const Render = (Component, props, location) => (
    
    <>
        {view === '' ? (
            <Box width="100%" height="100%">
                <Box width="100%" height="100%" display="flex">
                    <Box height="100%">
                        {
                            (
                                location !== '/psl/profiling' && 
                                location !== '/psl/welcome' &&
                                location !== '/psl/selection' &&
                                location !== '/psl/account-setup' &&
                                location !== '/psl/onboarding' &&
                                location.split("/")[3] !== 'news' &&
                                location.split("/")[3] !== 'article' &&
                                location.split("/")[3] !== 'updates'
                            ) 
                                && 
                            (
                                <Navigation side={1} />
                            )
                        }
                    </Box>
                    <Box display="flex" flexDirection="column" width="100%" height="100%">
                        {
                            (
                                location !== '/psl/welcome' &&
                                location !== '/psl/selection' &&
                                location !== '/psl/account-setup' &&
                                location !== '/psl/onboarding' &&
                                location.split("/")[3] !== 'news' &&
                                location.split("/")[3] !== 'article' &&
                                location.split("/")[3] !== 'updates' 
                            ) 
                                && 
                            ( 
                                <Navigation side={0} />
                            )
                        }
                        <Box height="100%" className="overflowY noScrollcss">
                            <Component {...props} />
                        </Box>
                    </Box> 
                </Box>
            </Box>
        ) : (
            <Box height="100%" width="100%" bgcolor="#FFFFFF">
                {/* {
                    location.split("/")[3] !== 'news' &&
                    location.split("/")[3] !== 'article' &&
                    location.split("/")[3] !== 'updates' &&
                    location.split("/")[3] === undefined &&
                    location !== '/psl/more' &&
                    location.split('/')[2] !== 'profile' &&
                    location !== '/psl/notification' &&
                    location !== '/psl/onboarding' &&
                    (<Navigation side={0} />)    
                } */}
                    <Component {...props} />
                {
                    location.split("/")[3] !== 'news' &&
                    location.split("/")[3] !== 'article' &&
                    location.split("/")[3] !== 'updates' &&
                    location.split("/")[3] === undefined &&
                    location.split('/')[2] !== 'profile' &&
                    location.split("/")[3] !== 'tool-access' &&
                    location !== '/psl/notification' &&
                    location !== '/psl/onboarding' &&
                    <Navigation side={2} />
                }
            </Box>
        )}
        <RenderAPI/>
    </>
)